import { h, Component } from 'preact';
import Home from '../routes/home';
import Axios from 'axios';

const target = {
	eventId: null,
	eventOwner: null,
	token: null,
	attendeeTypes: null,
	userAttendeeTypeId: null,
	mode: null,
	snapCardToken: null
};

const handler = {
	get(target, name) {
		return name in target ? target[name] : 42;
	},

	set(target, prop, value) {
		target[prop] = value;
		return true;
	}
};

function executePromise(
	eventId,
	eventOwner,
	token,
	attendeeTypes,
	userAttendeeTypeId,
	mode,
	snapCardToken
) {
	window.proxy.eventId = parseInt(eventId, 10);
	window.proxy.eventOwner = eventOwner;
	window.proxy.token = token;
	window.proxy.userAttendeeTypeId = parseInt(userAttendeeTypeId, 10);
	window.proxy.attendeeTypes = JSON.parse(attendeeTypes);
	window.proxy.mode = mode;
	window.proxy.snapCardToken = snapCardToken;
}

if (typeof window !== 'undefined') {
	window.proxy = new Proxy(target, handler);
	window.executePromise = executePromise;
}

// if (process.env.NODE_ENV === 'development')
if (typeof window !== "undefined") {
	console.log(JSON.stringify(window.proxy));
}


if (typeof window !== "undefined" && process.env.PREACT_APP_STAGING === 'true') {
	executePromise(
		11,
		'reconnect',
		'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzY19pZCI6MTYxNjgsInJvbGVzIjpbImV2ZW50X2FjY2VzcyJdfQ.jyrWFIBwk7sQRB-wX-D99ENoPx6Lwq-ynZE2ncFFitA',
		JSON.stringify([
			{"id": 109, "name": "Cine Locales"},
			{"id": 108, "name": "Cine Locales - VIP"},
			{"id": 107, "name": "Corporate Buyer"},
			{"id": 106, "name": "Wedding Planner"},
			{"id": 105, "name": "VIP Buyer"},
			{"id": 104, "name": "VIP"},
			{"id": 103, "name": "Speaker"},
			{"id": 102, "name": "Organisers"},
			{"id": 101, "name": "Media"},
			{"id": 100, "name": "Invitee"},
			{"id": 99, "name": "Hosted Buyer"},
			{"id": 87, "name": "Trade Visitor"},
			{"id": 86, "name": "Exhibitor"}
		]),
		87,
		'start',
		'8376e6560d477ca39fec6d7fd4e5446f2d8e590e'
	);
}
	
export const sendToNative = (command, data) => {
	let message = {
		cmd: command,
		data: JSON.stringify(data)
	};
	if (window && window.webkit && window.webkit.messageHandlers)
		window.webkit.messageHandlers.native.postMessage(message);
};

export default class App extends Component {
	state = {};

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	intervalId = null;

	componentDidMount() {
		const { eventId, eventOwner, token, attendeeTypes } = this.state;
		sendToNative('loaded', '');
		if (!eventId || !eventOwner || !token || !attendeeTypes) {
			this.intervalId = setInterval(() => {
				// eslint-disable-next-line react/no-did-mount-set-state
				this.setState({
					eventId: window.proxy.eventId,
					eventOwner: window.proxy.eventOwner,
					token: window.proxy.token,
					attendeeTypes: window.proxy.attendeeTypes,
					userAttendeeTypeId: window.proxy.userAttendeeTypeId,
					mode: window.proxy.mode
				});
				if (window.proxy.token && window.proxy.eventOwner) {
					// TODO: add a condition so only EA-Token for EA requests and Auth for SnapCard
					Axios.defaults.headers.common.Authorization = `Token ${window.proxy.snapCardToken}`;
					Axios.defaults.headers.common['EA-TOKEN'] = `${window.proxy.token}`;
					Axios.defaults.headers.common['EVENT-OWNER'] =
						window.proxy.eventOwner;
					clearInterval(this.intervalId);
				}
			}, 2000);
		}
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	render() {
		return <div id="app">{this.state.eventId && <Home {...this.state} sendToNative={sendToNative} />}</div>;
	}
}
